import { useContext } from 'react'
import { AuthContext } from '../contexts/authContext'

/**
 * Wraps the AuthContext for interacting with the Authentication Layer
 */
export const useAuth = () => useContext(AuthContext)
